import { DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingChargesQuickInfo extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacerMargin: HorizontalSpacer;
    horizontalspacerOtherCharge: HorizontalSpacer;
    horizontalspacerRate: HorizontalSpacer;
    horizontalspacerTaxes: HorizontalSpacer;
    horizontalspacerTotalWithTaxes: HorizontalSpacer;
    horizontalspacerType: HorizontalSpacer;
    horizontalspacerUnits: HorizontalSpacer;
    labelCarrierPay: Label;
    labelFreightChargeLabel: Label;
    labelLinehaulChg: Label;
    labelMargin: Label;
    labelMarginPercent: Label;
    labelOtherCharge: Label;
    labelOtherCharges: Label;
    labelOtherChargesTotal: Label;
    labelRate: Label;
    labelRateId: Label;
    labelRateIdLabel: Label;
    labelRateLabel: Label;
    labelRateType: Label;
    labelRatingUnits: Label;
    labelTaxCharges: Label;
    labelTaxChargesTotal: Label;
    labelTotalCarrierPay: Label;
    labelTotalCharges: Label;
    labelTotalChargesAmount: Label;
    labelTotalChargesWithTaxes: Label;
    labelTotalChargesWithTaxesTotal: Label;
    labelTotalLabel: Label;
    labelTotalMargin: Label;
    labelTotalMarginPercent: Label;
    labelTotalPay: Label;
    labelTotalPayCaption: Label;
    labelType: Label;
    labelUnits: Label;
    panelCarrier: Panel;
    panelOtherCharges: Panel;
    panelOtherChargesRows: Panel;
    panelRate: Panel;
    sourceBilling: DataSource;
    sourceInvoiceMargins: DataSource;
    sourceOtherChargeBill: DataSource;
}
